export type UserStatisticsKind = 'pure-originals' | 'masters';

export interface StatisticsRange {
    startDate: string;
    endDate: string;
}

export interface UserStatisticsPage<T> {
    content: T[];
    number: number;
    size: number;
    totalElements: number;
    totalPages: number;
    last: boolean;
}

export interface UserStatisticsFile {
    pureOriginalId?: number;
    masterId?: number;
    winOlsReference?: string | null;
    winOLSReference?: string | null;
    winOlsDbName?: string | null;
    actionDateTime: string | null;
    dateUploaded: string | null;
    dateUpdated?: string | null;
    dateExported?: string | null;
    ecuBuild: string | null;
    ecuProducer: string | null;
    vehicleProducer: string | null;
    vehicleSeries: string | null;
    vehicleModel: string | null;
    isDeleted: boolean;
}

export interface UserStatisticsAction {
    recordId: number;
    type: string;
    status: string;
    workTime: string | null;
}

export interface UserStatisticsActionDetail {
    type: string;
    workTime: string | null;
    changes?: {fieldName: string; oldValue: string | null; newValue: string | null}[];
    versionId?: number;
    versionName?: string;
    masterWinOlsReference?: string;
    pureOriginalMatchingId?: number;
    tuningName?: string;
    versionWinOlsReference?: string;
}

export interface UserStatisticsQuery extends StatisticsRange {
    pageNumber: number;
    pageSize: number;
    sortAttribute: string;
    sortDirection: 'asc' | 'desc';
    search?: string;
}

export function localStatisticsDate(date: Date): string {
    const pad = (n: number) => String(n).padStart(2, '0');
    return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}T${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`;
}

export function statisticsRange(start?: string | null, end?: string | null): StatisticsRange {
    const now = new Date();
    const midnight = new Date(now);
    midnight.setHours(0, 0, 0, 0);
    const startValue = start ? new Date(start) : midnight;
    const endValue = end ? new Date(end) : now;
    if (isNaN(startValue.getTime()) || isNaN(endValue.getTime()) || startValue > endValue) {
        throw new Error('Select a valid date range. The start must be before the end.');
    }
    return {startDate: localStatisticsDate(startValue), endDate: localStatisticsDate(endValue)};
}

export function formatStatisticsDate(value?: string | null): string {
    if (!value) return '—';
    const match = /^(\d{2})-(\d{2})-(\d{4})-(\d{2})-(\d{2})-(\d{2})$/.exec(value);
    const normalized = match ? `${match[3]}-${match[2]}-${match[1]}T${match[4]}:${match[5]}:${match[6]}` : value;
    const date = new Date(normalized);
    return isNaN(date.getTime()) ? value : date.toLocaleString('en-GB', {
        day: '2-digit', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit'
    });
}
